import React from "react"
import { graphql } from "gatsby"
import Meta from "../components/Meta"
import styled from "styled-components"
import ArticleContent from "../components/article/ArticleContent"
//import PageTitle from "../components/PageTitle"
//import PostContent from "../components/post/PostContent"
//import PageContent from "../components/PageContent"

const PostPage = ({ data }) => {
  
  return (
    <>
        <Meta
          type="article"
          title={`${data.post.title} | ${data.site.siteMetadata.title}`}
          description={data.post.excerpt.replace(/<\/?[^>]+(>|$)/g, "")}
          uri={data.post.uri}
          image={data.post.featuredImage.node.localFile.publicURL}
        />
        <main>
          <StyledWrap>
            {/*<PageContent borderTop={false}>
              <PageTitle>{data.post.title}</PageTitle>
              <PostContent post={data.post} />
  </PageContent>*/}
              <PageTitle>{data.post.title}</PageTitle>
              <ArticleContent article={data.post} />
          </StyledWrap>
        </main>
    </>
  )
}


export default PostPage;


const PageTitle = styled.h1`
  position: relative;
  z-index: 1;
  margin: 0 auto 0;
  line-height: 1.7;
  font-size: 1.125em;
  font-family: var(--font-heading);
  text-transform: uppercase;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.2em;
  max-width: 36em;
  padding-left: 0.2em;
  @media ( min-width: 48em ) {
    font-size: 1.375em;
  }
`;

const StyledWrap = styled.article`
  padding: 4em 0;
  @media ( min-width: 48em ) {
    padding-top: 6em;
  }
`


export const query = graphql`
  query($id: String!) {
    site {
      id
      siteMetadata {
          title
      }
    }

    post: wpPost(id: { eq: $id }) {
      title
      content
      excerpt
      uri
      featuredImage {
        node {
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(width: 1024)
            }
          }
        }
      }
    }
  }
`
/*

    posts: allWpPost(sort: {order: DESC, fields: date}, filter: {categories: {nodes: {elemMatch: {id: {eq: $categoryId}}}}}) {
      edges {
        node {
          title
          excerpt
          uri
          slug
        }
      }
    }
featuredImage {
  node {
    localFile {
      childImageSharp {
        gatsbyImageData(width: 1024)
      }
    }
  }
}
*/
